export default __webpack_public_path__ + "static/media/foto-exponente1.4b88550c.png";